import type { Offer } from '@/types/offer.types';

export function calculateOfferDiscount(subtotal: number, offer: Offer | null | undefined): number {
  if (!offer || subtotal <= 0) return 0;

  if (offer.discountPercentage) {
    return Math.round((subtotal * offer.discountPercentage) / 100 * 100) / 100;
  }

  if (offer.discountAmount) {
    return Math.min(offer.discountAmount, subtotal);
  }

  return 0;
}

export function calculateAmountAfterDiscount(subtotal: number, discount: number): number {
  return Math.max(0, Math.round((subtotal - discount) * 100) / 100);
}

export function calculatePaymentAdjustment(amountAfterDiscount: number, amountReceived: number | null | undefined): number | null {
  if (amountReceived == null || Number.isNaN(amountReceived)) return null;
  return Math.round((amountAfterDiscount - amountReceived) * 100) / 100;
}

export function formatOfferLabel(offer: Offer): string {
  if (offer.discountPercentage) {
    return `${offer.title} (${offer.discountPercentage}% off)`;
  }
  if (offer.discountAmount) {
    return `${offer.title} (₹${offer.discountAmount} off)`;
  }
  return offer.title;
}
